import React from 'react';
import { KompisIcon } from '@inter-ikea-kompis/react-components';
import { getKompisIconData, IconProps } from './utils/kompis/getKompisIconData';

export const Icon: React.FunctionComponent<IconProps> = ({
  iconName,
  ...props
}) => <KompisIcon {...props} {...getKompisIconData(iconName)} />;
